import { render, staticRenderFns } from "./HeadAdmin.vue?vue&type=template&id=b19c05d0&scoped=true&"
import script from "./HeadAdmin.vue?vue&type=script&lang=js&"
export * from "./HeadAdmin.vue?vue&type=script&lang=js&"
import style0 from "./HeadAdmin.vue?vue&type=style&index=0&id=b19c05d0&scoped=true&lang=css&"
import style1 from "./HeadAdmin.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19c05d0",
  null
  
)

export default component.exports